<!--  Preload loading gif -->
<img style="display: none" src="/assets/img/loading.gif" alt="Loading...">
<div class="text-center">
  <img src="/assets/img/loading.gif" alt="Loading...">
  <h5>Loading...</h5>
</div>


